export type Point = [number, number];

/// Point should be an array with two numbers in [lon, lat] order
export function getGeoJsonPointGeometry(point: Point) {
    return {
        "type": "Point",
        "coordinates": point,
    };  
}

/// Input should be an array of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonMultiPointGeometry(points: Point[]) {
    return {
        "type": "MultiPoint",
        "coordinates": points,
    };  
}

/// Input should be an array of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonLineStringGeometry(points: Point[]) {
    return {
        "type": "LineString",
        "coordinates": points,
    };
}

/// Input should be an array of arrays of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonMultiLineStringGeometry(points: Point[][]) {
    return {
        "type": "MultiLineString",
        "coordinates": points,
    };
}

/// Input should be an array of arrays of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonPolygonGeometry(points: Point[][]) {
    return {
        "type": "Polygon",
        "coordinates": points,
    };
}

/// Input should be an array polygons.
/// Each polygon should be an array of arrays of points.
/// Each point should be an array with two numbers in [lon, lat] order
export function getGeoJsonMultiPolygonGeometry(points: Point[][]) {
    return {
        "type": "MultiPolygon",
        "coordinates": points,
    };
}

export function getGeoJsonCollectionGeometry(geometries: {[key: string]: any}[]) {
    return {
        "type": "GeometryCollection",
        "geometries": geometries,
    };
}
